import React from "react";
import "./providerSection.scss";
import ProviderImage from "../../../../assets/images/provider.png";
import { NavLink } from "react-router-dom";
export default function ProviderSection() {
  return (
    <div>
      <div className="provider-all-content-section-alignment">
        <div className="grid">
          <div className="grid-items">
            <div className="image-center-alignment">
              <NavLink to="/kontakt">
                <img
                  className="animate__backInUp animate__animated wow"
                  data-wow-offset="100"
                  src={ProviderImage}
                  alt="ProviderImage"
                />
              </NavLink>
            </div>
          </div>
          <div className="grid-items">
            <p
              className="animate__slideInUp animate__animated wow"
              data-wow-offset="100"
            >
              Nutzen Sie das bundesweite Netzwerk der Deutscher Immobilien
              Dienst GmbH für Ihren Außendienst.
            </p>
            <ul>
              <li
                className="animate__slideInUp animate__animated wow"
                data-wow-offset="100"
              >
                Wir haben Profis, die nach Ihren Vorgaben einen Nachmieter
                finden.
              </li>
              <li
                className="animate__slideInUp animate__animated wow"
                data-wow-offset="100"
              >
                Wir bereiten die vollständigen Bewerbungsunterlagen der
                Interessenten für Sie auf. Auf Wunsch holen wir die
                Vertragsunterschriften ein.
              </li>
              <li
                className="animate__slideInUp animate__animated wow"
                data-wow-offset="100"
              >
                Wir führen die Abnahmen und Übergaben durch. Diese
                protokollieren wir nach Ihren Vorgaben.
              </li>
              <li
                className="animate__slideInUp animate__animated wow"
                data-wow-offset="100"
              >
                In Mietersprechstunden geben unsere Immobilienkaufleute Ihren
                Mietern die Möglichkeit, ihre Wünsche persönlich aufzugeben. Die
                Gespräche werden nach Ihren Vorgaben protokolliert und an Sie
                übermittelt.
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}
